import { Typography } from "@mui/material";
import { AmountSliderView } from "./AmountSliderView/AmountSliderView";
import { DenominationView } from "./DenominationView";

export const GiftPriceView = ({ gift, onChange, value }) => {
  return (
    <>
      <Typography sx={{ fontSize: "1.875rem", fontWeight: 700 }}>{gift.name}</Typography>
      {/* <Typography sx={{ color: "#AAAABE" }}>Life is like a water fall, you've gotta flow</Typography> */}
      <div style={{ marginTop: "1.875rem" }}>
        <Typography sx={{ color: "#AAAABE" }}>Price</Typography>

        {gift.denominations.length === 0 && <AmountSliderView onChange={(newValue) => onChange(newValue)} gift={gift} voucherValue={value} />}

        {gift.denominations.length > 0 && <DenominationView onChange={(newValue) => onChange(newValue)} gift={gift} voucherValue={value} denominations={gift.denominations} />}
      </div>
    </>
  );
};
